import React from "react";
import svgPaths from "./svgPaths";
import imgUnion from "../assets/images/appliance repair - our services.png";
import imgFrame427321783 from "../assets/images/plumbing- our services.png";
import imgUnion1 from "../assets/images/bc54d8da2a13479b46afd145581c88701ce38671.png";
import imgFrame427321787 from "../assets/images/maid service - our services.png";

function IconsaxLinearSearchnormal() {
  return (
    <div className="relative size-[20px] flex items-center justify-center" data-name="Iconsax/Linear/searchnormal1">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 21 21">
        <g id="Iconsax/Linear/searchnormal1">
          <path d={svgPaths.p80f87d0} id="Vector" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </g>
      </svg>
    </div>
  );
}

function Group2() {
  return (
    <div className="flex items-center justify-center shrink-0">
      <IconsaxLinearSearchnormal />
    </div>
  );
}

export default function Services() {
  return (
    <div className="w-full bg-white relative overflow-hidden flex flex-col gap-8 px-6 py-12 lg:h-[1719px] lg:w-[1440px] lg:mx-auto lg:block lg:px-0 lg:py-0">
      {/* Title */}
      <h2 className="font-['Inter:Semi_Bold',sans-serif] font-semibold text-3xl md:text-4xl lg:text-[48px] text-black text-center leading-tight relative w-full max-w-4xl mx-auto lg:absolute lg:left-1/2 lg:-translate-x-1/2 lg:top-[67px] lg:w-[965px] lg:mx-0">
        Everything Your Home Needs, All in One Place.
      </h2>

      {/* Search services bar */}
      <div className="relative w-full max-w-md mx-auto h-[60px] flex items-center lg:absolute lg:left-1/2 lg:-translate-x-1/2 lg:top-[260px] lg:w-[500px] lg:mx-0">
        <div className="absolute border border-[rgba(0,0,0,0.1)] border-solid h-[60px] rounded-[100px] w-full" />
        <div className="absolute bg-[#107cf7] flex flex-col items-start px-[23px] py-[16px] right-[4px] rounded-[100px] top-[4px] h-[52px] justify-center cursor-pointer hover:bg-blue-600 transition-colors">
          <Group2 />
        </div>
        <p className="absolute capitalize font-['Inter:Regular',sans-serif] font-normal leading-[30px] left-[32px] text-[16px] text-black/50 select-none">
          search services...
        </p>
      </div>

      {/* Services Grid cards */}
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-8 mt-6 relative lg:absolute lg:left-1/2 lg:-translate-x-1/2 lg:top-[420px] lg:w-[1440px] lg:h-[1234px] lg:block lg:mt-0">
        
        {/* Card 1: Appliance Repair */}
        <div className="relative bg-white border border-[rgba(0,0,0,0.1)] border-solid h-auto p-6 rounded-[30px] flex flex-col gap-4 lg:absolute lg:w-[766px] lg:h-[517px] lg:left-[604px] lg:top-[48px] lg:p-0">
          <div className="relative w-full h-[200px] rounded-[20px] overflow-hidden lg:absolute lg:h-[477px] lg:left-[19px] lg:top-[19px] lg:w-[725.997px] lg:rounded-none">
            <img alt="Appliance Repair" className="absolute block inset-0 object-cover size-full" src={imgUnion} />
          </div>
          <div className="flex flex-col gap-2 relative z-10 lg:absolute lg:left-[431px] lg:top-[19px] lg:right-[30px]">
            <h3 className="font-['Inter:Bold',sans-serif] font-bold text-2xl lg:text-[36px] text-[#1e1e1e] opacity-90">
              Appliance Repair
            </h3>
            <p className="font-['Inter:Regular',sans-serif] font-normal leading-[1.85] text-sm lg:text-[16px] text-[#1e1e1e] opacity-80">
              Keep your home running smoothly with expert repair and installation services for refrigerators, ovens, microwaves, washing machines, and more.
            </p>
          </div>
        </div>

        {/* Card 2: Plumbing */}
        <div className="relative bg-white border border-[rgba(0,0,0,0.1)] border-solid h-auto p-6 rounded-[30px] flex flex-col-reverse gap-4 lg:absolute lg:w-[488px] lg:h-[517px] lg:left-[70px] lg:top-[48px] lg:p-0">
          <div className="relative w-full h-[200px] rounded-[20px] overflow-hidden lg:absolute lg:h-[309px] lg:w-[451px] lg:left-[18px] lg:top-[187px] lg:rounded-[30px]">
            <img alt="Plumbing" className="absolute block inset-0 object-cover size-full" src={imgFrame427321783} />
          </div>
          <div className="flex flex-col gap-2 relative z-10 lg:absolute lg:left-[18px] lg:top-[28px] lg:right-[18px]">
            <h3 className="font-['Inter:Bold',sans-serif] font-bold text-2xl lg:text-[36px] text-[#1e1e1e] opacity-90">
              Plumbing
            </h3>
            <p className="font-['Inter:Regular',sans-serif] font-normal leading-[1.85] text-sm lg:text-[16px] text-[#1e1e1e] opacity-80">
              From leaky faucets to complete pipe repairs, our verified plumbers provide quick, reliable, and hassle-free solutions for every home.
            </p>
          </div>
        </div>

        {/* Card 3: Electrician */}
        <div className="relative bg-white border border-[rgba(0,0,0,0.1)] border-solid h-auto p-6 rounded-[30px] flex flex-col gap-4 lg:absolute lg:w-[772px] lg:h-[521px] lg:left-[70px] lg:top-[665px] lg:p-0">
          <div className="relative w-full h-[200px] rounded-[20px] overflow-hidden lg:absolute lg:h-[481px] lg:left-[19px] lg:top-[19px] lg:w-[732px] lg:rounded-none">
            <img alt="Electrician" className="absolute block inset-0 object-cover size-full" src={imgUnion1} />
          </div>
          <div className="flex flex-col gap-2 relative z-10 lg:absolute lg:left-[19px] lg:top-[26px] lg:w-[327px]">
            <h3 className="font-['Inter:Bold',sans-serif] font-bold text-2xl lg:text-[36px] text-[#1e1e1e] opacity-90">
              Electrician
            </h3>
            <p className="font-['Inter:Regular',sans-serif] font-normal leading-[1.85] text-sm lg:text-[16px] text-[#1e1e1e] opacity-80">
              From fixing faulty wiring and installing switches to lighting upgrades and electrical maintenance, our certified electricians ensure safe, reliable, and efficient service for your home.
            </p>
          </div>
        </div>

        {/* Card 4: Maid Services */}
        <div className="relative bg-white border border-[rgba(0,0,0,0.1)] border-solid h-auto p-6 rounded-[30px] flex flex-col-reverse gap-4 lg:absolute lg:w-[472px] lg:h-[521px] lg:left-[898px] lg:top-[665px] lg:p-0">
          <div className="relative w-full h-[200px] rounded-[20px] overflow-hidden lg:absolute lg:h-[286px] lg:w-[432px] lg:left-[19px] lg:top-[214px] lg:rounded-[30px]">
            <img alt="Maid Services" className="absolute block inset-0 object-cover size-full" src={imgFrame427321787} />
          </div>
          <div className="flex flex-col gap-2 relative z-10 lg:absolute lg:left-[19px] lg:top-[21px] lg:right-[19px]">
            <h3 className="font-['Inter:Bold',sans-serif] font-bold text-2xl lg:text-[36px] text-[#1e1e1e] opacity-90">
              Maid Services
            </h3>
            <p className="font-['Inter:Regular',sans-serif] font-normal leading-[1.85] text-sm lg:text-[16px] text-[#1e1e1e] opacity-80">
              Enjoy a cleaner, more comfortable home with trained and verified housekeeping professionals for regular cleaning, deep cleaning, and everyday household assistance.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}